// extracted by mini-css-extract-plugin
export default {"tic":"SupplyIn_tic__6eQiw","dd":"SupplyIn_dd__l1jIz"};